import tagTester from './_tagTester.js';

export default tagTester('Object');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_hasObjectTag.js
// module id = 9qRI
// module chunks = 0